module.exports = __webpack_public_path__ + "static/project-2-5-71bca85dc8fc9b8464163f226be61b73.jpg";